import { call, put, select, takeLatest } from 'typed-redux-saga'
import { MerchantStatusModel } from 'Pages/admin/merchantStatus'
import { errorHandler, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog, ProductStatusModel } from 'Models'
import {
	merchantStatusSelectors,
	MerchantStatusNS,
	merchantStatusSlice,
	merchantStatusApi,
} from 'Pages/admin'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'

function* getList(action: MerchantStatusNS.GetMerchantStatusList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(merchantStatusSlice.actions.clearAll())
		}
		const res = yield* call(merchantStatusApi.getAll, requestParams)
		const merchantStatus = new ResponseCatalog<MerchantStatusModel>(res)
		if (!clear) {
			const oldMerchantStatus = yield* select(merchantStatusSelectors.selectEntries)
			merchantStatus.entries = oldMerchantStatus.concat(res.entries)
		}
		yield* put(merchantStatusSlice.actions.setAll(merchantStatus))
		yield* put(merchantStatusSlice.actions.setRequestParams(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOne(action: MerchantStatusNS.GetOne) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const res = yield* call(merchantStatusApi.getOne, action.payload)
		yield* put(merchantStatusSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createOne(action: MerchantStatusNS.CreateOne) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const res = yield* call(merchantStatusApi.createOne, action.payload)
		yield* put(merchantStatusSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.admin_panel.merchant_status))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* updateOne(action: MerchantStatusNS.UpdateOne) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const res = yield* call(merchantStatusApi.updateOne, action.payload.id, action.payload.data)
		yield* put(merchantStatusSlice.actions.setOne(res))
		action.payload.callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* deleteOne(action: MerchantStatusNS.DeleteOne) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		yield* call(merchantStatusApi.deleteOne, action.payload)
		yield* put(merchantStatusSlice.actions.getAll)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getProductStatuses(action: MerchantStatusNS.GetProductStatuses) {
	try {
		let params: RequestParams
		if (action.payload.params) {
			params = action.payload.params
		} else {
			params = yield* select(merchantStatusSelectors.getStatusParams)
		}
		const res = yield* call(merchantStatusApi.getProductStatus, params)
		const productOrderStatuses = new ResponseCatalog<ProductStatusModel>(res)
		yield* put(merchantStatusSlice.actions.setProductStatuses(productOrderStatuses))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* merchantStatusSaga() {
	yield* takeLatest(merchantStatusSlice.actions.getAll.type, getList)
	yield* takeLatest(merchantStatusSlice.actions.getOne.type, getOne)
	yield* takeLatest(merchantStatusSlice.actions.createOne.type, createOne)
	yield* takeLatest(merchantStatusSlice.actions.updateOne.type, updateOne)
	yield* takeLatest(merchantStatusSlice.actions.deleteOne.type, deleteOne)
	yield* takeLatest(merchantStatusSlice.actions.getProductStatuses.type, getProductStatuses)
}
